import { render, staticRenderFns } from "./IntegrationStep2.vue?vue&type=template&id=244439a0&"
import script from "./IntegrationStep2.vue?vue&type=script&lang=js&"
export * from "./IntegrationStep2.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationStep2.vue?vue&type=style&index=0&id=244439a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports